/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/indent */
import * as yup from "yup";

// Interfaces
import Schema from "../types/Schema.interface";
import Statement, { Validation } from "../types/Statement.interface";

// Misc.
import { isPresentInArray } from "./Array.lib";

export default function createYupSchema(
  currentSchema: Schema,
  statement: Statement
): Schema {
  const schema: Schema = { ...currentSchema };

  const { _id, validationType, validations = [], conditions } = statement;

  /**
   * Exit early if no validationType is given or no
   * yup Validation exists for given validationType
   */
  if (!validationType || !yup[validationType]) {
    return schema;
  }

  // Create new Yup Validation-Function with corresponding Type (e.g. String or Array)
  let validator: any = new yup[validationType]();

  /**
   * Add Validation Mechanisms to Validator
   */
  const addValidationMechanisms = (validation: Validation) => {
    const { params, validationType: type } = validation;

    if (!validator[type]) {
      // eslint-disable-next-line no-console
      console.log(`No Validator found for type "${type}"`);
      return;
    }

    validator = validator[type](...params);
  };

  const getSchemaForConditions = () => {
    const yupType = validationType === "array" ? "array" : "object";
    const yupValidator = (yup[yupType] as yup.MixedSchemaConstructor)();
    const yupReturn =
      validationType === "array"
        ? validator
        : yup.object({
            id: yup.string().optional(),
            value: validator,
          });

    // Abort if no Conditions are set
    if (!conditions || conditions.length === 0) {
      return yupReturn;
    }

    const returnData = conditions.map((condition) => {
      const { type, statementId, answerId } = condition;

      if (type === "!==") {
        return yupValidator.when(`${statementId}`, {
          is: (value: any) => {
            if (Array.isArray(value)) {
              return !isPresentInArray(value, answerId);
            }

            return value !== answerId;
          },
          then: yupReturn,
          otherwise: yupValidator.optional(),
        });
      }
      return yupValidator.when(`${statementId}`, {
        is: (value: any) => {
          if (Array.isArray(value)) {
            return isPresentInArray(value, answerId);
          }

          return value.id === answerId;
        },
        then: yupReturn,
        otherwise: yupValidator.optional(),
      });
    });

    /**
     * Currently only one condition is supported ("required").
     * If there are multiple conditions to be supported in the future
     * this return statement and the function in general should be refactored.
     */
    return returnData[0];
  };

  /**
   * Iterate all Validations set for the Statement and add validation mechanisms
   * to the value field
   */
  validations.forEach(addValidationMechanisms);

  schema[_id] = getSchemaForConditions();

  return schema;
}
